import React from 'react';
import Classes from './LegalDoc.module.css';

// Shared layout for the Privacy Policy and Terms of Service pages.
// sections: [{ title, body?: [paragraph], list?: [item], after?: [paragraph] }]
export default function LegalDoc({ title, effectiveDate, intro, sections }) {
    return (
        <main className={Classes.page}>
            <article className={Classes.doc}>
                <h1>{title}</h1>
                <p className={Classes.date}>Effective date: {effectiveDate}</p>
                {intro.map((p, i) => <p key={i}>{p}</p>)}

                {sections.map((s, i) => (
                    <section key={s.title}>
                        <h2>{i + 1}. {s.title}</h2>
                        {(s.body || []).map((p, j) => <p key={j}>{p}</p>)}
                        {s.list && (
                            <ul>
                                {s.list.map((item, j) => <li key={j}>{item}</li>)}
                            </ul>
                        )}
                        {(s.after || []).map((p, j) => <p key={j}>{p}</p>)}
                    </section>
                ))}
            </article>
        </main>
    );
}
